export const personalDataModule = {
  namespaced: true,
  state: {
    name: null,
    surname: null,
    email: null,
    phone: null,
    agreement: false,
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_SURNAME: (state, surname) => {
      state.surname = surname;
    },
    SET_EMAIL: (state, email) => {
      state.email = email;
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone;
    },
    SET_AGREEMENT: (state, value) => {
      state.agreement = value;
    },
    CLEAR_ALL: (state) => {
      state.name = null;
      state.surname = null;
      state.email = null;
      state.phone = null;
      state.agreement = null;
    },
  },
  getters: {
    name: (state) => {
      return state.name;
    },
    surname: (state) => {
      return state.surname;
    },
    email: (state) => {
      return state.email;
    },
    phone: (state) => {
      return state.phone;
    },
    agreement: (state) => {
      return state.agreement;
    },
    isFullPersonalData: (state) => {
      return (
        !!state.name &&
        !!state.surname &&
        !!state.phone &&
        !!state.email &&
        state.agreement
      );
    },
    isValidEmail: (state) => {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const extension = state.email.substring(
        state.email.indexOf("@") + 1,
        state.email.lastIndexOf(".")
      );
      return re.test(state.email) && extension !== "example";
    },
  },
  actions: {
    clearAll(ctx) {
      ctx.commit("CLEAR_ALL");
    },
  },
};
